const BYTE_CONSTANT = 1024;
const KILO_POWER = 1;
const MEGA_POWER = 2;
const GIGA_POWER = 3;
const TERA_POWER = 4;
const PETA_POWER = 5;

const MAX_DIGITS = 2;
const MAX_DIGITS_TB = 4;

const DEFAULT_UNIT = 'Bytes';
const UNIT_PB = 'PB';
const UNIT_TB = 'TB';
const UNIT_GB = 'GB';
const UNIT_MB = 'MB';
const UNIT_KB = 'KB';
const UNITS = [UNIT_KB, UNIT_MB, UNIT_GB, UNIT_TB, UNIT_PB];
const UNIT_POW = 1;
const DIVISION_BORDER = 1;

export const byteUtils = {
    bytesToPeta:           amount => amount / Math.pow(BYTE_CONSTANT, PETA_POWER),
    bytesToTera:           amount => amount / Math.pow(BYTE_CONSTANT, TERA_POWER),
    bytesToGiga:           amount => amount / Math.pow(BYTE_CONSTANT, GIGA_POWER),
    bytesToMega:           amount => amount / Math.pow(BYTE_CONSTANT, MEGA_POWER),
    bytesToKilo:           amount => amount / Math.pow(BYTE_CONSTANT, KILO_POWER),
    petaToBytes:           amount => amount * Math.pow(BYTE_CONSTANT, PETA_POWER),
    teraToBytes:           amount => amount * Math.pow(BYTE_CONSTANT, TERA_POWER),
    gigaToBytes:           amount => amount * Math.pow(BYTE_CONSTANT, GIGA_POWER),
    megaToBytes:           amount => amount * Math.pow(BYTE_CONSTANT, MEGA_POWER),
    kiloToBytes:           amount => amount * Math.pow(BYTE_CONSTANT, KILO_POWER),
    convertBytesAndFormat: (amount,numberFormatter) => {
        const value = byteUtils.convertBytes(amount);
        return `${numberFormatter(value.amount, {maximumFractionDigits: MAX_DIGITS})}`;

    },
    convertBytesAndFormatWithSymbol: (amount,numberFormatter, unit=undefined) => {
        const value = byteUtils.convertBytes(amount, unit);
        return `${numberFormatter(value.amount, {maximumFractionDigits: MAX_DIGITS})} ${value.unit}`;

    },
    convertBytes: (amount, givenUnit) => UNITS.reduce((ret, unit, index) => {
        const pow = index + UNIT_POW;
        const value = amount / Math.pow(BYTE_CONSTANT, pow);

        if (Math.abs(value) < DIVISION_BORDER) {
            return ret;
        }
        unit = givenUnit ? givenUnit : unit
        return {
            amount: value,
            unit
        };
    }, {
        amount,
        unit: givenUnit ? givenUnit : DEFAULT_UNIT
    }),
    formatWithSymbol: (amount,numberFormatter) => {
        if (amount < 1) {
            return `${numberFormatter(amount, {maximumFractionDigits: MAX_DIGITS_TB})} ${UNIT_TB}`;
        }

        return `${numberFormatter(amount, {maximumFractionDigits: MAX_DIGITS})} ${UNIT_TB}`;
    }
};



// WEBPACK FOOTER //
// ./src/util/bytes.js